import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PcsCardModel from './pcs-card.ts';

export default class PcsDisputeModel extends Model {
  @attr declare provider: string;
  @attr declare providerId: string;
  @attr declare providerData: Record<string, unknown>;
  @attr declare state: string;
  @attr declare transitionLog: Record<string, unknown>;
  @attr declare amount: number;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('pcs-card', { async: false, inverse: 'pcsDisputes' })
  declare pcsCard: PcsCardModel;

  [Type] = 'pcs-dispute' as const;
}
